export type Resource = {
  id: string;
  title: string;
  intro: string;
  examples: string[];
  openLabel: string;
  groups: {title?: string; items: string[]}[];
};

export const resources: Resource[] = [
  {
    "id": "models",
    "title": "专业模型",
    "intro": "使用垂直领域内最专业的工具完成高水平的工作",
    "examples": [
      "AlphaFold2",
      "Boltz-2",
      "RFdiffusion"
    ],
    "openLabel": "查看全部 10 项",
    "groups": [
      {
        "title": "结构预测",
        "items": [
          "AlphaFold2",
          "Boltz-2",
          "Chai-1",
          "ABodyBuilder3"
        ]
      },
      {
        "title": "分子与抗体设计",
        "items": [
          "RFdiffusion",
          "ProteinMPNN",
          "LigandMPNN",
          "AntiFold",
          "BioPhi · Sapiens 人源化"
        ]
      },
      {
        "title": "分子对接",
        "items": [
          "GNINA"
        ]
      }
    ]
  },
  {
    "id": "workflows",
    "title": "工作流",
    "intro": "使用成熟或自定义的工作流快速落实您的想法",
    "examples": [
      "蛋白与多肽设计",
      "抗体人源化",
      "小分子筛选"
    ],
    "openLabel": "查看全部 5 项",
    "groups": [
      {
        "items": [
          "蛋白与多肽设计及候选筛选",
          "抗体人源化与结构复核",
          "小分子准备、对接与候选筛选",
          "配体环境下的序列设计与复核",
          "抗体 CDR 设计与候选筛选"
        ]
      }
    ]
  },
  {
    "id": "analysis",
    "title": "数据分析",
    "intro": "用 R 和 Python 在数据科学领域轻松进行专业分析",
    "examples": [
      "统计分析",
      "生存分析",
      "科研绘图"
    ],
    "openLabel": "查看分析能力",
    "groups": [
      {
        "items": [
          "数据读取与整理",
          "描述统计与分布检查",
          "统计假设检验",
          "相关与回归分析",
          "生存分析",
          "效应量与置信区间",
          "统计功效与样本量估计",
          "科研绘图",
          "分析结果导出"
        ]
      }
    ]
  },
  {
    "id": "databases",
    "title": "数据库",
    "intro": "便捷检索专业数据库，为您的研究找到所需数据",
    "examples": [
      "UniProt",
      "Ensembl",
      "PubChem"
    ],
    "openLabel": "查看全部 40 项",
    "groups": [
      {
        "title": "蛋白与结构",
        "items": [
          "UniProt",
          "RCSB PDB",
          "PDBe",
          "AlphaFold DB",
          "InterPro",
          "Pfam",
          "SIFTS",
          "EMDB",
          "Complex Portal"
        ]
      },
      {
        "title": "基因与变异",
        "items": [
          "Ensembl",
          "NCBI Gene",
          "NCBI dbSNP",
          "ClinVar",
          "gnomAD",
          "UCSC Genome Browser",
          "MyGene.info",
          "MyVariant.info",
          "Ensembl BioMart"
        ]
      },
      {
        "title": "基因调控与本体",
        "items": [
          "JASPAR",
          "UniBind",
          "ENCODE cCREs",
          "QuickGO",
          "EMBL-EBI OLS"
        ]
      },
      {
        "title": "化合物与药理",
        "items": [
          "PubChem",
          "BindingDB",
          "Guide to PHARMACOLOGY",
          "SureChEMBL",
          "ChEBI"
        ]
      },
      {
        "title": "通路、靶点与互作",
        "items": [
          "Reactome",
          "IntAct",
          "WikiPathways",
          "Open Targets"
        ]
      },
      {
        "title": "表达与组学",
        "items": [
          "NCBI GEO",
          "ArrayExpress / BioStudies",
          "GTEx",
          "Human Protein Atlas",
          "Expression Atlas",
          "Single Cell Expression Atlas"
        ]
      },
      {
        "title": "临床研究",
        "items": [
          "openFDA",
          "ClinicalTrials.gov"
        ]
      }
    ]
  },
  {
    "id": "literature",
    "title": "文献",
    "intro": "检索与深入阅读专业文献，轻松掌握领域研究进展",
    "examples": [
      "PubMed",
      "Europe PMC",
      "OpenAlex"
    ],
    "openLabel": "查看全部 6 项",
    "groups": [
      {
        "items": [
          "PubMed",
          "Europe PMC",
          "OpenAlex",
          "Crossref",
          "arXiv",
          "bioRxiv / medRxiv"
        ]
      }
    ]
  },
  {
    "id": "experiments",
    "title": "实验资源",
    "intro": "连接智能实验室，用真实实验验证您的研究想法",
    "examples": [
      "蛋白表达",
      "结合筛选",
      "亲和力表征",
      "热稳定性",
      "荧光检测"
    ],
    "openLabel": "查看全部 5 项",
    "groups": [
      {
        "items": [
          "蛋白表达",
          "结合筛选",
          "亲和力表征",
          "热稳定性",
          "荧光检测"
        ]
      }
    ]
  }
];

export const websiteFaqs = [
  [
    "Sciland 适合什么研究？",
    "Sciland 支持文献调研、研究设计、数据分析、计算研究和成果写作。生物医学是当前重点优化的领域；具体可执行范围取决于数据、软件、技能和计算环境。"
  ],
  [
    "需要下载客户端吗？",
    "需要。Sciland 以桌面客户端为主，官网提供下载、注册与账户入口。支持 macOS Apple 芯片与 Windows 64 位。请在下载页选择对应系统的安装包。"
  ],
  [
    "一定要从研究设计开始吗？",
    "不需要。你可以从一个问题、一组数据或已有研究材料开始。讨论、调研、分析、审核和写作会根据研究进展交叉进行。"
  ],
  [
    "Chat 和 Research 如何选择？",
    "临时问答、资料整理和相对独立的任务可以使用 Chat。需要围绕课题持续推进时，使用 Research 组织设计、任务与成果。需要深入时，请在新的 Research 中粘贴整理好的背景摘要，并重新附上所需文件。"
  ],
  [
    "如何使用模型与工作流？",
    "在客户端打开“模型 · 工作流”，选择官方工作流，查看输入与参数。也可以复制工作流后调整节点。模型运行需具备对应的计算服务与环境条件。"
  ],
  [
    "怎样开始湿实验？",
    "在客户端“湿实验”入口选择实验类型，准备序列及所需靶标信息，提交需求后与团队确认方案、交付内容与周期。"
  ],
  [
    "我能在研究过程中调整方向吗？",
    "可以。你可以补充背景与证据、提出要求、调整方向或停止任务。研究设计和待办也可以随着新发现更新。"
  ],
  [
    "研究数据和结果如何管理？",
    "项目文件和运行环境主要在本机，模型与账户功能依赖在线服务。分析材料和交付文件支持查看与追溯；研究结果仍需结合领域知识审阅和验证。"
  ]
];
